import Translate from "localization/translate";
import TR from "./tr.json";

const translate = new Translate(TR);

export default translate;
